const EmptyBlockPro = () => {
  return null;
};

export default EmptyBlockPro;
